module.exports = __webpack_public_path__ + "img/ce4179a.gif";